/* eslint-disable no-undef */
import { useTranslation, withTranslation } from "react-i18next"
import { Grid } from '@mui/material/';
import React from "react";
import SETTINGS from './../../utils/constants';
import LogoComponent from '../header/logo.jsx';
import '../../utils/common.scss';
import DoctorProfile from './../doctorProfile/doctorProfile.jsx';
import PriceTable from "./../priceTable/priceTable.jsx";
import ContactUs from "../contactUs/contactUs.jsx";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types'

const BodyPage=(props)=>{
  const {t} = useTranslation()
  const clinicInfoArray = t('clinicInfo', {returnObjects: true})
  const theme = useTheme()
  const lessThanMedium = useMediaQuery(theme.breakpoints.down("md"))
  const {clinicInfoRef, priceInfoRef, contactRef} = props

  return(
    <Grid container sx={{height: 'auto', backgroundColor: SETTINGS.BACKGROUND_COLOR, color: SETTINGS.DEEP_COLOR}} className="general-text">
      <Grid item xs={0} lg={1.5}/>
      <Grid item xs={12} lg={9} sx={{backgroundColor: SETTINGS.TERTIARY_COLOR}}>
        <Grid direction="column" container>
          <Grid sx={{height: '15vh'}}></Grid>
          <Grid item className="center-item" sx={{height: '80vh'}}>
            <LogoComponent fill={SETTINGS.SECONDARY_COLOR}/>
          </Grid>
          <Grid item>
            <Grid container>
              <Grid item xs={2}></Grid>
              <Grid item xs={8} sx={{borderBottom: 'solid 1px', borderColor: SETTINGS.DEEP_COLOR}}></Grid>
              <Grid item xs={2}></Grid>
            </Grid>
          </Grid>
          <Grid item ref={clinicInfoRef}>
            {clinicInfoArray.map((infoItem, index)=>{
              if(lessThanMedium){
                return(
                  <Grid container className="center-item" key={index} sx={{marginTop: '50px'}}>
                      <Grid item xs={12} className="center-item">
                        <img src={`${process.env.PUBLIC_URL}/clinicInfo/${infoItem.id}.jpg`} alt="clinicInfo" style={{maxWidth: '300px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'}}/>  
                      </Grid>
                      <Grid item xs={12} sx={{padding: '30px'}}>
                        <div className="general-title">
                          {t(infoItem.title)}
                        </div>
                        {t(infoItem.description)}
                      </Grid>
                  </Grid>
                )
              } else{
                return(
                  <Grid container className="center-item" sx={{marginTop: '50px'}} key={index}>
                    <Grid item xs={1}></Grid>
                    {index%2===0?
                      <Grid item md={5} sx={{padding: '30px'}}>
                        <div className="general-title">
                          {t(infoItem.title)}
                        </div>
                        {t(infoItem.description)}
                      </Grid>
                      :
                      <Grid item md={5} className="center-item">
                        <img src={`${process.env.PUBLIC_URL}/clinicInfo/${infoItem.id}.jpg`} alt="clinicInfo" style={{maxWidth: '400px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'}}/> 
                      </Grid>
                    }
                    {index%2===0?
                      <Grid item md={5} className="center-item">
                        <img src={`${process.env.PUBLIC_URL}/clinicInfo/${infoItem.id}.jpg`} alt="clinicInfo" style={{maxWidth: '400px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'}}/> 
                      </Grid>
                      :
                      <Grid item md={5} sx={{padding: '30px'}}>
                        <div className="general-title">
                          {t(infoItem.title)}
                        </div>
                        {t(infoItem.description)}
                      </Grid>
                    }
                    <Grid item xs={1}></Grid>
                  </Grid>
                )
              }
            })}
          </Grid>
          <Grid item sx={{margin: '60px 0px'}}>
            <Grid container direction="row">
              <Grid item xs={1}></Grid>
              <Grid item xs={10}>
                <DoctorProfile />
              </Grid>
              <Grid item xs={1}></Grid>
            </Grid>
          </Grid>
          <Grid item ref={priceInfoRef} style={{marginBottom:'120px'}}></Grid>
          <Grid item>
            <Grid container direction="row">
              <Grid item xs={1}></Grid>
              <Grid item xs={10}>
                <PriceTable />
              </Grid>
              <Grid item xs={1}></Grid>
            </Grid>
          </Grid>
          <Grid item ref={contactRef}>
            <Grid container direction="row">
              <Grid item xs={1}></Grid>
              <Grid item xs={10}>
                <ContactUs />
              </Grid>
              <Grid item xs={1}></Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={0} lg={1.5}/>
    </Grid>
  )
}

BodyPage.propTypes = {
  clinicInfoRef: PropTypes.any,
  priceInfoRef: PropTypes.any,
  contactRef: PropTypes.any
}

export default withTranslation()(BodyPage)